import React from 'react';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import CreatedMeetingCoPilotTableLayout from './created-meeting-co-pilot-table-layout';
import { ORIGINAL_TEXT_LABEL } from '../meeting-co-pilot.texts';
import { MeetingCoPilotVM } from '../meeting-co-pilot.viewmodal';
import './created-meeting-co-pilot-form.scss';

interface IProps {
    vm: MeetingCoPilotVM;
}

const CreatedMeetingCoPilotFormPresentation = mobxReact.observer((props: IProps) => {
    const {
        vm
    } = props;
    const intl = useIntl();

    /* [OEP-14168] - temporary hidden
    const field = {
        value: vm.getMeetingTemplateId(),
        setValue: (value: string) => vm.setMeetingTemplateId(value),
    };

    const customOptions = (): JSX.Element => {
        return (
            <>
                <option value={''}>{intl.formatMessage(NO_TEMPLATE_SELECTED_TEXT)}</option>
                {
                    vm.getTemplatesOptions().map(({ blueprintId, name }) => {
                        return <option value={blueprintId} key={blueprintId}>{name}</option>;
                    })
                }
            </>
        );
    };*/

    return (
        <form className='oe-form'>
            <div className='oe-form_body created-meeting-co-pilot-form'>
                <div className='created-meeting-co-pilot-form__fields'>
                    <FormField className='oe-form-field'>
                        <label className='created-meeting-co-pilot-form__original-text-label'>
                            {intl.formatMessage(ORIGINAL_TEXT_LABEL)}
                        </label>
                        <p className='created-meeting-co-pilot-form__original-text'>
                            {vm.meetingCoPilotText}
                        </p>
                    </FormField>
                    {/* [OEP-14168] - temporary hidden
                     {vm.canApplyTemplateToMeeting()
                        && <FormFieldInput.Select
                                field={field}
                                labelDescriptor={MEETING_TEMPLATE_TEXT}
                                customOptions={customOptions()}
                                fieldClassName='oe-form-field meeting-co-pilot-form__template-selector'
                            />
                    }*/}
                </div>
                <CreatedMeetingCoPilotTableLayout
                    createdByAIMeetingsList={vm.generatedMeetings}
                    eventTimeZone={vm.eventTimeZone}
                />
            </div>
        </form>
    );
});

export { CreatedMeetingCoPilotFormPresentation };
